import createAuth from './create_auth';

export default createAuth('admin');
